(function() {
  'use strict';

  var prevReached = false;
  var checkTimer = null;

  function readConfig() {
    var el = document.getElementById('cart-rewards-bar');
    if (!el) return null;
    var threshold = parseFloat(el.getAttribute('data-threshold'));
    if (isNaN(threshold)) return null;
    return { threshold: threshold, prop: '_gift' };
  }

  function subtotalSemBrinde(cart, cfg) {
    var total = 0;
    cart.items.forEach(function(i) {
      if (!(i.properties && i.properties[cfg.prop])) total += i.final_line_price;
    });
    return total;
  }

  function updateUI(cart, cfg) {
    var el = document.getElementById('cart-rewards-bar');
    if (!el) return;

    var real = cart.items.filter(function(i) {
      return !(i.properties && i.properties[cfg.prop]);
    });
    if (!real.length) { el.style.display = 'none'; return; }
    el.style.display = 'block';

    var sub = subtotalSemBrinde(cart, cfg) / 100;
    var reached = sub >= cfg.threshold;
    var pct = Math.min((sub / cfg.threshold) * 100, 100);

    var fill = document.getElementById('crb-fill');
    var d1 = document.getElementById('crb-d1');
    var msg = document.getElementById('crb-msg');
    if (!fill || !d1 || !msg) return;

    fill.style.width = pct + '%';
    d1.classList.toggle('crb__dot--on', reached);

    if (reached && !prevReached) {
      d1.classList.add('crb__dot--pop');
      setTimeout(function() { d1.classList.remove('crb__dot--pop'); }, 500);
    }

    el.classList.toggle('crb--done', reached);

    if (reached) {
      msg.innerHTML = '<strong>Parab\u00e9ns!</strong> Voc\u00ea ganhou <strong>Frete Gr\u00e1tis!</strong>';
    } else {
      var f = Math.ceil(cfg.threshold - sub);
      msg.innerHTML = 'Falta <span class="crb__val">R$' + f + '</span> para ganhar <strong>Frete Gr\u00e1tis!</strong>';
    }

    prevReached = reached;
  }

  function checkOnce() {
    var cfg = readConfig();
    if (!cfg) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateUI(cart, cfg); })
      .catch(function(e) { console.error('[CRB]', e); });
  }

  function scheduleCheck() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(checkOnce, 500);
  }

  var listenersReady = false;
  function setupListeners() {
    if (listenersReady) return;
    listenersReady = true;

    document.addEventListener('cart:updated', function() { scheduleCheck(); });
    document.addEventListener('cart:refresh', function() { scheduleCheck(); });
    document.addEventListener('page:loaded', function() { scheduleCheck(); });
    document.addEventListener('shopify:section:load', function() { scheduleCheck(); });

    var origFetch = window.fetch;
    window.fetch = function() {
      var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var promise = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/') !== -1 && url.indexOf('/cart.js') === -1 && url.indexOf('sections=') === -1) {
        promise.then(function() { setTimeout(scheduleCheck, 800); }).catch(function(){});
      }
      return promise;
    };
  }

  setInterval(function() {
    var el = document.getElementById('cart-rewards-bar');
    if (!el) return;
    var drawer = document.querySelector('#mini-cart');
    if (!drawer) return;
    var isVisible = drawer.offsetParent !== null || drawer.classList.contains('is-open') || getComputedStyle(drawer).display !== 'none';
    if (isVisible) checkOnce();
  }, 3000);

  function init() {
    prevReached = false;
    setupListeners();
    checkOnce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CartRewardsBar = { check: checkOnce, init: init };
})();